<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />
        <div v-if="!loading">
          <crud-list
            v-model="servicos"
            :headers="headers"
            :actions="actions"
            :permission="'list_servico'"
            :sort-by="['codigo','nome']"
            :sort-desc="[false]"
            export-pdf-xlsx
          >
            <template
              v-if="$store.getters.hasPermission('inserir_servico')"
              v-slot:btnCadastro
            >
              <v-col>
                <v-btn
                  color="primary"
                  block
                  title="Cadastrar novo serviço"
                  rounded
                  class="text-none text-white"
                  @click="$router.push({ path: 'servicos/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import servicosStore, { BOOTSTRAP, INATIVAR_SERVICOS } from '@/store/modules/servicos'
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    name: 'ServicoList',
    components: {
    },
    data () {
      return {
        actions: [
          {
            title: 'Editar Serviço',
            color: 'info darken-3',
            click: item => this.editarServico(item),
            icon: 'mdi-pencil',
            permission: 'editar_servico',
          },
          {
            title: 'Excluir Serviço',
            color: 'red darken-3',
            click: item => this.INATIVAR_SERVICOS(item),
            icon: 'mdi-trash-can-outline',
            permission: 'excluir_servico',
          },
        ].filter(({ permission }) => store.getters.hasPermission(permission)),
        headers: [
          { text: '', value: 'actions', sortable: false, floatingfilter: false, groupable: false, width: '40px' },
          { align: 'right', sortable: true, floatingfilter: true, groupable: false, text: 'Código', value: 'codigo', width: 'auto', report: true },
          { align: 'left', sortable: true, floatingfilter: true, groupable: false, text: 'Nome', value: 'nome', width: 'auto', report: true },
          { align: 'left', sortable: true, floatingfilter: true, groupable: true, text: 'Unidade', value: 'unidade.nome', width: 'auto', report: true },
          { align: 'left', sortable: true, floatingfilter: true, groupable: true, text: 'Categoria', value: 'categoria.nome', width: 'auto', report: true },
          { align: 'left', sortable: true, floatingfilter: true, groupable: true, text: 'Descrição', value: 'descricao', width: 'auto', report: true },
        ],

      }
    },
    computed: {
      ...mapState('servicos', ['loading', 'servicos']),
    },
    async created () {
      if (!this.$store.hasModule('servicos')) { this.$store.registerModule('servicos', servicosStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('servicos', [BOOTSTRAP, INATIVAR_SERVICOS]),
      ...mapGetters(['hasPermission']),
      editarServico ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/cdc/servicos/alterar`,
          query: { id },
        })
      },
    },
  }

</script>
